import {Directive, ElementRef, HostListener, Input} from '@angular/core';

@Directive({
    standalone: true,
    selector: '[appImageFallback]'
})
export class ImageFallbackDirective {
    @Input() appImageFallback: string = "";

    @HostListener('error') onError() {
        this.el.nativeElement.src = this.appImageFallback;
    }

    constructor(private el: ElementRef) {

    }
}
